import { AbstractApi } from '@/api/AbstractApi'
import { UpdateConfiguration } from '@/model/configuration/UpdateConfiguration'
import request from '@/api/request'

class ConfigurationApi extends AbstractApi {
  async update(updated: UpdateConfiguration) {
    const route = this.generateAdminRoute({ suffix: 'frontend' })

    return request.put(route, updated)
  }

  async show() {
    const route = this.generateAdminRoute({ suffix: 'frontend' })

    return request.get(route)
  }
}

export default new ConfigurationApi('configuration')
